import {actionTypeGenerator, stateGenerator} from "../utils";

export const COURSE_RUN_DEMAND = actionTypeGenerator('courseRunDemand');
export const COURSE_RUN = actionTypeGenerator('course');

let initialState = {
  demand: stateGenerator(true),
  original: stateGenerator(true)
};

export function course(state = initialState, action) {
  switch (action.type) {
    /** Course run demand */
    case COURSE_RUN_DEMAND.list.loading:
      return {
        ...state,
        demand: {
          ...state.demand, data: null,
          list: {...state.demand.list, isLoading: true}
        }
      };

    case COURSE_RUN_DEMAND.list.get:
      return {
        ...state,
        demand: {
          ...state.demand,
          list: {
            ...state.demand.list,
            data: action.payload.results,
            count: action.payload.count,
            isLoading: false
          }
        }
      };

    case COURSE_RUN_DEMAND.list.error:
      return {
        ...state,
        demand: {
          ...state.demand,
          list: {...state.demand.list, error: action.payload, isLoading: false}
        }
      };

      /** Course Original resource */
    case COURSE_RUN.list.loading:
      return {
        ...state,
        original: {
          ...state.original, data: null,
          list: {...state.original.list, isLoading: true}
        }
      };

    case COURSE_RUN.list.get:
      return {
        ...state,
        original: {
          ...state.original,
          list: {
            ...state.original.list,
            data: action.payload.results,
            count: action.payload.count,
            isLoading: false
          }
        }
      };

    case COURSE_RUN.list.error:
      return {
        ...state,
        original: {
          ...state.original,
          list: {...state.original.list, error: action.payload, isLoading: false}
        }
      };

    default:
      return state;

  }
}